module.exports = __webpack_public_path__ + "3ba3b14be6af2bec89dfdf73281a4e91.pdf";